// import { mapState } from 'vuex'
export default {
  computed: {
    getuserinfo() {
      return JSON.parse(localStorage.getItem('userInfo'));
    }

  },

  mounted() {
    console.log(this.getuserinfo);
  }

};